import { useState, type MouseEvent } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import type { Dependent } from '@/data/collaborators/dependents/interfaces';
import { ManageDependentDialog } from '@/packages/dependents/components/manage-dependent-dialog';
import { RemoveDependentDialog } from '@/packages/dependents/components/remove-dependent-dialog';
import { ResetDependentPasswordDialog } from '@/packages/dependents/components/reset-dependent-password-dialog';

export const DependentMenu = ({ dependent }: { dependent: Dependent }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showManageDependentDialog, setShowManageDependentDialog] =
    useState(false);
  const [showRemoveDependentDialog, setShowRemoveDependentDialog] =
    useState(false);
  const [
    showResetDependentPasswordDialog,
    setShowResetDependentPasswordDialog,
  ] = useState(false);

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleResetDependentPassword = () => {
    setShowResetDependentPasswordDialog(true);
    handleClose();
  };

  const handleRemoveDependent = () => {
    setShowRemoveDependentDialog(true);
    handleClose();
  };

  const handleManageDependent = () => {
    setShowManageDependentDialog(true);
    handleClose();
  };

  return (
    <>
      <Stack direction="row" spacing={1}>
        <Box>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={(e) => handleOpen(e)}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            elevation={5}
            open={Boolean(anchorEl)}
            onClose={() => handleClose()}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleManageDependent}>Editar</MenuItem>
            <MenuItem onClick={handleResetDependentPassword}>
              Redefinir senha
            </MenuItem>
            <MenuItem onClick={handleRemoveDependent}>Remover</MenuItem>
          </Menu>
        </Box>
      </Stack>
      {showManageDependentDialog && (
        <ManageDependentDialog
          dependent={dependent}
          onClose={() => setShowManageDependentDialog(false)}
        />
      )}
      {showRemoveDependentDialog && (
        <RemoveDependentDialog
          dependentId={dependent.id}
          onClose={() => setShowRemoveDependentDialog(false)}
        />
      )}
      {showResetDependentPasswordDialog && (
        <ResetDependentPasswordDialog
          dependent={dependent}
          onClose={() => setShowResetDependentPasswordDialog(false)}
        />
      )}
    </>
  );
};
